const PROGRESS_BEGIN = 'PROGRESS_BEGIN'
const PROGRESS_UPDATE = 'PROGRESS_UPDATE'
const PROGRESS_END = 'PROGRESS_END'

const initialState = {
	progress_count: 0,
	progressing: false,

	message: null,
	// -1 - нет сведений, отображаем ожидалку
	value: -1
}

const actions = {
	begin({commit}, {message = null, value = -1}) {
		commit(PROGRESS_BEGIN, message, value)
	},

	update({commit}, {value}) {
		commit(PROGRESS_UPDATE, value)
	},

	end({commit, dispatch}) {
		// When calling end() just after begin()progress dialog
		// is hidden but overlay is not, delay solves this.
		setTimeout(function () {
			dispatch('end_internal')
		}, 10)
	},

	end_internal({commit}) {
		commit(PROGRESS_END)
	}
}

const mutations = {
	[PROGRESS_BEGIN](state, message = null, value = -1) {
		state.progress_count += 1
		state.progressing = true

		if (message != null) {
			state.message = message
		}

		state.value = value
	},

	[PROGRESS_UPDATE]
		(state, value) {
		state.value = value
	},

	[PROGRESS_END](state) {
		state.progress_count -= 1
		if (state.progress_count === 0) {
			state.progressing = false
		}

		state.value = -1
	},
}

const getters = {
	progressing: function (state) {
		return state.progressing
	},

	message: function (state) {
		return state.message
	},

	value: function (state) {
		return state.value
	}
}

export default {
	namespaced: true,
	state: initialState,
	getters,
	actions,
	mutations
}